import { useDispatch, useSelector } from "react-redux";
import { storeInfoApi } from "../api/storeInfoApi";
import { getInfo } from "../../../modules/reducers/landing/storeInfo";
import { useEffect, useState } from "react";
import { storeStatusApi } from "../api/storeStatusApi";
import { getStoreStatus } from "../../../modules/reducers/landing/storeStatus";
import { setBranchId } from "../../../modules/reducers/getBranches/getBranches";
import { gameScheduleApi } from "../api/gameScheduleApi";
import { getGameScheduleInfo } from "../../../modules/reducers/landing/gameSchedule";

const useStoreInform = () => {
  const [needSelectBranch, setNeedSelectBranch] = useState(false);
  const brandId = useSelector((state) => state.checkArsStatus.brandId);
  const [nobrandStoreId, setNobrandStoreId] = useState(null);
  const branchName = useSelector((state) => state.storeInfo.branchName);
  const storeClose = useSelector((state) => state.storeInfo.storeClose);
  const workingTime = useSelector((state) => state.storeInfo.workingTime);
  const location = useSelector((state) => state.storeInfo.location);
  const cashless = useSelector((state) => state.storeInfo.cashless);
  const fc = useSelector((state) => state.storeInfo.fc);

  const storeId = useSelector((state) => state.checkArsStatus.branchId);
  const isOpen = useSelector((state) => state.storeStatus.jobType);
  const selectedBranchId = useSelector(
    (state) => state.getBranches.selectedBranchId
  );

  const loading = useSelector((state) => state.storeInfo.loading);
  const tel = useSelector((state) => state.checkArsStatus.channelTypeCd);
  const selectedBranchTel = useSelector((state) => state.getBranches.tel);
  const homeAway = useSelector((state) => state.gameSchedule.homeAway);
  const stadium = useSelector((state) => state.gameSchedule.stadium);
  const requiresBranchSelection = !["EM", "TR", "LD"].includes(brandId);
  const dispatch = useDispatch();

  useEffect(() => {
    if (requiresBranchSelection && (selectedBranchId || storeId)) {
      setNobrandStoreId(selectedBranchId || storeId);

      if (!selectedBranchTel) {
        dispatch(
          setBranchId({
            selectedBranchId: selectedBranchId || storeId,
            selectedBranchName: branchName,
            tel: tel
          })
        )
      }
    }
  }, [selectedBranchId, storeId]);

  useEffect(() => {
    if (requiresBranchSelection && !selectedBranchId && !storeId) {
      setNeedSelectBranch(true);
    }
  }, [brandId, selectedBranchId]);

  useEffect(() => {
    let api;
    if (nobrandStoreId && needSelectBranch === false) {
      api = storeInfoApi(nobrandStoreId);
      dispatch(getInfo(api));
      api = storeStatusApi(nobrandStoreId);
      dispatch(getStoreStatus(api));
    } else if (storeId && needSelectBranch === false) {
      if (brandId === "LD") {
        api = gameScheduleApi();
        dispatch(getGameScheduleInfo(api));
      } else {
        api = storeInfoApi(storeId);
        dispatch(getInfo(api));
        api = storeStatusApi(storeId);
        dispatch(getStoreStatus(api));
      }
    }
  }, [storeId, nobrandStoreId]);

  return {
    branchName,
    storeClose,
    workingTime,
    location,
    needSelectBranch,
    isOpen,
    cashless,
    fc,
    loading,
    brandId,
    homeAway,
    stadium
  };
};

export default useStoreInform;
